import { Address, Policy } from '@amfam/policy/models';
import { PolicyChangeRequestType } from '@amfam/shared/models';

export class ChangeRequest {
  public policyList: Policy[];
  public firstName: string;
  public lastName: string;
  public address: Address;
  public email: string;
  public phone: string;
  public comment: string;
  public customerId: string;
  public policyChangeType: PolicyChangeRequestType;
  public riskDescription: string;
  public typeInput: string;
  public requestedChange: string;
  public currentLenderName: string;
  public newLenderName: string;
  public lenderToBeRemoved: string;
  public selectedPolicyNumber: string;
  public addLenderName: string;
  public addressChange?: AddressChange;
  public driverLicenseChange?: DriverLicenseChange;
  public vinChange?: VinChange;
  public requestChange: RequestChange;
}

export class InitialChangeRequestState {
  public policyList = null;
  public firstName = null;
  public lastName = null;
  public address = null;
  public email = null;
  public phone = null;
  public comment = null;
  public customerId = null;
  public policyChangeType = null;
  public riskDescription = null;
  public typeInput = null;
  public requestedChange = null;
  public currentLenderName = null;
  public newLenderName = null;
  public lenderToBeRemoved = null;
  public selectedPolicyNumber = null;
  public addLenderName = null;
  public addressChange = null;
  public driverLicenseChange = null;
  public vinChange = null;
  public requestChange = null;
}
export interface VehicleRiskDescription {
  riskId: string;
  riskDescription: string;
}

export interface RequestChange {
  agentId: string;
  agentName: string;
  agencyEmail: string;
  agentEmail: string;
  customerId?: string;
  partnerId?: string;
  customerFirstName: string;
  customerName: string;
  policyNumbers: string;
  phoneNumbers: string;
  emailAddress: string;
  mailingAddress: string;
}

export interface AddressChange {
  agentId: string;
  agentName: string;
  agencyEmail: string;
  agentEmail: string;
  customerId?: string;
  partnerId?: string;
  customerFirstName: string;
  customerName: string;
  policyNumbers: string;
  existingAddress: string;
  phoneNumbers: string;
  emailAddress: string;
  newAddress: string;
  sendDocuments: string;
  vehiclesGaraged: string;
  vehicles: string;
  reason: string;
}

export interface DriverLicenseChange {
  agentId: string;
  agentName: string;
  customerId?: string;
  partnerId?: string;
  customerFirstName: string;
  customerName: string;
  policyNumbers: string;
  phoneNumbers: string;
  emailAddress: string;
  mailingAdrress: string;
  driver: string;
  licenseNumber: string;
  state: string;
  reason: string;
}

export interface VinChange {
  whyUpdateVin: string;
  vehicle: string;
  currentVin: string;
  currentYear: number;
  newVin: string;
  newYear: number;
  make?: string;
  model?: string;
  series?: string;
  reason: string;
}
